var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggle-switch bg-white w-8 h-4 flex items-center rounded-full p-1 duration-200 ease-in-out border-2",class:[
    _vm.optionalClass, 
    _vm.queryStatus == 'visible' ? 'border-blue-600 border-2' : 'border-custom-dark'
  ],on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}},[_c('div',{staticClass:"toggle-view w-5 h-5 rounded-full shadow-md transform duration-200 ease-in-out",class:[
      _vm.status ? 'translate-x-2 bg-card-bg' : '-translate-x-1',
      _vm.queryStatus == 'visible' && !_vm.status ? 'bg-blue-600' : (_vm.status ? 'bg-card-bg' : 'bg-custom-dark')
    ]})])
}
var staticRenderFns = []

export { render, staticRenderFns }